const COLORS = [
  'oklch(50.5% 0.213 27.518)', // 'red-700'
  'oklch(55.3% 0.195 38.402)', // 'orange-700'
  'oklch(48.8% 0.243 264.376)', // 'blue-700'
  'oklch(53.2% 0.157 131.589)', // 'lime-700'
  'oklch(52.7% 0.154 150.069)', // 'green-700'
  'oklch(49.6% 0.265 301.924)', // 'purple-700'
  'oklch(51.1% 0.096 186.391)', // 'teal-700'
  'oklch(52% 0.105 223.128)', // 'cyan-700'
  'oklch(45.7% 0.24 277.023)', // 'indigo-700'
  'oklch(49.1% 0.27 292.581)', // 'violet-700'
  'oklch(50.8% 0.118 165.612)', // 'emerald-700'
  'oklch(51.8% 0.253 323.949)', // 'fuchsia-700'
  'oklch(55.4% 0.135 66.442)', // 'yellow-700'
  'oklch(52.5% 0.223 3.958)', // 'pink-700'
  'oklch(51.4% 0.222 16.935)', // 'rose-700'
  'oklch(50% 0.134 242.749)', // 'sky-700'
  'oklch(37.2% 0.044 257.287)', // 'slate-700'
  'oklch(55.5% 0.163 48.998)', // 'amber-700'
];

const getDeterministicIndex = (key: string): number => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    const char = key.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return Math.abs(hash) % COLORS.length;
};

const getUniqueColor = (key: string, alpha?: number): string => {
  const color = COLORS[getDeterministicIndex(key)];
  if (alpha !== undefined && alpha >= 0 && alpha <= 100) {
    return color.replace(')', ` / ${alpha}%)`);
  }
  return color;
};

export { getUniqueColor };
